module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/mv_photowedding_02-5ec2cc712faf6a6def5d15d6929b5dc6.webp";